/* TopNavi — Airtable header behavior
   Vanilla JS, no jQuery. Loaded with `defer` from layout/theme.liquid. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initMobileDrawer();
    initSearchOverlay();
    initStickyHeader();
    initMegaMenu();
    initPredictiveSearch();
    initBrandFilter();
  }

  /* ---------------------------------------------------------------------
     MOBILE DRAWER
     --------------------------------------------------------------------- */
  function initMobileDrawer() {
    const toggle = document.querySelector('[data-mobile-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    if (!toggle || !drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', open);
    overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-drawer-close]').forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Accordion submenu inside drawer
    drawer.querySelectorAll('[data-submenu-toggle]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const item = btn.closest('[data-drawer-item]');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* ---------------------------------------------------------------------
     SEARCH OVERLAY
     --------------------------------------------------------------------- */
  function initSearchOverlay() {
    const triggers = document.querySelectorAll('[data-search-toggle]');
    const overlay = document.querySelector('[data-search-overlay]');
    if (!triggers.length || !overlay) return;
    const input = overlay.querySelector('[data-search-input]');
    const panel = overlay.querySelector('.tn-search-panel');

    function updatePanelPadding() {
      const header = document.querySelector('.tn-header');
      if (!header || !panel) return;
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      panel.style.paddingTop = (bottom + 28) + 'px';
    }

    function open() {
      updatePanelPadding();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(() => input.focus(), 80);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    window.addEventListener('scroll', () => {
      if (overlay.classList.contains('is-open')) updatePanelPadding();
    }, { passive: true });
    window.addEventListener('resize', updatePanelPadding);

    triggers.forEach(t => t.addEventListener('click', open));
    overlay.querySelectorAll('[data-search-close]').forEach(el => el.addEventListener('click', close));
    overlay.addEventListener('click', e => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    // Expose toggle for header inline icons (legacy compatibility)
    window.toggleSearch = function () {
      overlay.classList.contains('is-open') ? close() : open();
    };
  }

  /* ---------------------------------------------------------------------
     STICKY HEADER (shadow on scroll)
     --------------------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.querySelector('[data-at-header]');
    if (!header) return;
    let last = 0;
    function onScroll() {
      const y = window.scrollY;
      if (y > 12 && last <= 12) header.classList.add('is-scrolled');
      else if (y <= 12 && last > 12) header.classList.remove('is-scrolled');
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------------
     MEGA-MENU — close non-active siblings instantly when entering one
     --------------------------------------------------------------------- */
  function initMegaMenu() {
    const items = document.querySelectorAll('.tn-nav-item.has-mega, .at-nav-item.has-mega');
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        items.forEach(other => {
          if (other !== item) other.classList.add('no-delay');
        });
        item.classList.remove('no-delay');
      });
    });
  }

  /* ---------------------------------------------------------------------
     BRAND FILTER — kliens-oldali szűrő a brand megamenü mezőin
     --------------------------------------------------------------------- */
  function initBrandFilter() {
    document.querySelectorAll('[data-brand-filter]').forEach(input => {
      const wrapper = input.closest('.tn-mega-brand, .at-mega-brand');
      if (!wrapper) return;
      const cells = wrapper.querySelectorAll('.tn-mega-brand-cell, .at-mega-brand-cell');
      const empty = wrapper.querySelector('[data-brand-empty]');

      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        let visible = 0;
        cells.forEach(cell => {
          const name = cell.dataset.brandName || cell.textContent.toLowerCase();
          const match = !q || name.includes(q);
          cell.classList.toggle('is-hidden', !match);
          if (match) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });

      // Ne csukja be a megamenüt, ha a kereső kap kattintást
      input.addEventListener('click', e => e.stopPropagation());
    });
  }

  /* ---------------------------------------------------------------------
     PREDICTIVE SEARCH — preserves CR-V/CX-5 normalization from legacy
     --------------------------------------------------------------------- */
  // Márkák / rövidítések, amiket NE alakítson át a normalizer
  const NEVER_NORMALIZE = new Set([
    'BMW','AMG','AUDI','OPEL','KIA','VW','SEAT','TDI','TSI','TFSI','GTD','FSI','GTI','GTS','GTR','GTX',
    'AWD','FWD','RWD','SUV','HEV','PHEV','EV','MID','HQ','HD','USB','GPS','DSP','DAB','LED','OEM',
    'ECO','MPV','RS','RS3','RS4','RS5','RS6','RS7'
  ]);
  // Csak ezek a 3-betűs prefixek kapnak CR-V stílusú kötőjelezést
  const KNOWN_V_PREFIXES = new Set(['CR','HR','BR','ZR','WR','XR']);

  function normalizeCarModelQuery(raw) {
    const q = raw.trim();
    // Ha az input MÁR strukturált (tartalmaz szóközt, kötőjelet, vagy pontot),
    // a user explicit "márka + modell" formát írt — tiszteletben tartjuk és
    // változatlanul küldjük tovább. ("Audi A3", "BMW E46", "Toyota RAV4", "CR-V" stb.)
    if (/[\s\-\.]/.test(q)) return q;

    // Csak ezután fut a model-kód normalizáló — pl. "CRV" → "CR-V", "CX5" → "CX-5".
    const clean = q.toUpperCase();
    if (NEVER_NORMALIZE.has(clean)) return q;
    const map = {
      'CRV': 'CR-V', 'HRV': 'HR-V', 'BRV': 'BR-V', 'ZRV': 'ZR-V', 'WRV': 'WR-V',
      'CX5': 'CX-5', 'CX3': 'CX-3', 'CX30': 'CX-30', 'CX60': 'CX-60', 'CX90': 'CX-90',
      'RAV4': 'RAV 4', 'CHR': 'C-HR', 'TROC': 'T-Roc', 'TCROSS': 'T-Cross',
    };
    if (map[clean]) return map[clean];
    if (clean.length === 3 && clean.endsWith('V') && KNOWN_V_PREFIXES.has(clean.slice(0, 2))) {
      return clean.slice(0, 2) + '-V';
    }
    const m = clean.match(/^([A-Z]{1,5})([0-9]{1,3})([A-Z]{0,2})$/);
    if (m) return m[1] + '-' + m[2] + (m[3] ? ' ' + m[3] : '');
    return q;
  }

  function formatPrice(rawPrice) {
    let formatted = String(rawPrice);
    if (!/^[\d\s.,]+$/.test(formatted.trim())) return formatted;
    const cleanStr = formatted.replace(/\s/g, '').replace(',', '.');
    const value = parseFloat(cleanStr);
    if (isNaN(value)) return formatted;
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'HUF';
    if (cur === 'HUF') return new Intl.NumberFormat('hu-HU', { style: 'decimal', maximumFractionDigits: 0 }).format(value) + ' Ft';
    if (cur === 'EUR') return '€' + value.toFixed(2).replace('.', ',');
    if (cur === 'RON') return value.toFixed(0) + ' Lei';
    if (cur === 'PLN') return value.toFixed(2).replace('.', ',') + ' zł';
    return value + ' ' + cur;
  }

  function vendorPriority(vendor) {
    if (vendor === 'Márkaspecifikus multimédia') return 2;
    if (vendor === 'Márkaspecifikus tolatókamera') return 1;
    return 0;
  }

  function initPredictiveSearch() {
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    const searchUrl = (document.documentElement.dataset.searchUrl) || '/search';
    const strings = (window.theme && window.theme.strings && window.theme.strings.custom && window.theme.strings.custom.search) || {
      view_all: 'View all', no_results: 'No results found', min_chars: 'Type at least 2 characters',
    };
    if (!input || !results) return;

    let timer;
    input.addEventListener('input', e => {
      clearTimeout(timer);
      timer = setTimeout(() => runSearch(e.target.value), 120);
    });

    function runSearch(rawQuery) {
      const original = rawQuery.trim();
      const primary  = normalizeCarModelQuery(rawQuery);
      if (original.length === 0) {
        results.innerHTML = '';
        results.classList.remove('is-visible');
        return;
      }
      if (original.length === 1) {
        results.innerHTML = `<div class="at-search-empty">${strings.min_chars}</div>`;
        results.classList.add('is-visible');
        return;
      }

      // Query variánsok — az ORIGINAL legyen az ELSŐ (legnagyobb relevancia),
      // utána a normalize-elt (ha más), végül szóköz/kötőjel-mentes fallback.
      const variants = [original];
      if (primary && primary !== original) variants.push(primary);
      const stripped = original.replace(/[\s\-\.]/g, '');
      if (stripped !== original && stripped.length > 1 && !variants.includes(stripped)) {
        variants.push(stripped);
      }

      // Loading állapot azonnal látszódjék, ne villogjon a régi tartalom
      results.innerHTML = `
        <div class="tn-loader-wrap" role="status" aria-live="polite">
          <div class="tn-loader-dots"><span></span><span></span><span></span></div>
          <p class="tn-loader-text">Keresés folyamatban…</p>
        </div>`;
      results.classList.add('is-visible');

      Promise.all(variants.map(v =>
        fetch(`/search/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=10`).then(r => r.json())
      )).then(allData => {
        const seen = new Set();
        const products = [];
        // Az első variáns (= original) találatai kerülnek elsőként a tömbbe;
        // a további variánsok csak új ID-ket adnak hozzá.
        for (const data of allData) {
          for (const p of (data.resources && data.resources.results && data.resources.results.products) || []) {
            if (!seen.has(p.id)) { seen.add(p.id); products.push(p); }
          }
        }
        if (!products.length) {
          results.innerHTML = `<div class="at-search-empty">${strings.no_results}</div>`;
          results.classList.add('is-visible');
          return;
        }

        // === RELEVANCIA RENDEZÉS ===
        // 1. EXACT title-match (a teljes original query benne van a title-ban)
        // 2. Vendor priority (Márkaspecifikus multimédia = 2, tolatókamera = 1)
        // 3. Eredeti API-sorrend (Shopify saját relevancia)
        const origLower = original.toLowerCase();
        const origNoSpace = origLower.replace(/\s+/g, '');
        products.forEach((p, i) => {
          const tLower = String(p.title || '').toLowerCase();
          const tNoSpace = tLower.replace(/\s+/g, '');
          p.__titleHit = tLower.includes(origLower) || tNoSpace.includes(origNoSpace);
          p.__origIdx = i; // tie-breaker
        });
        products.sort((a, b) => {
          // 1. Title-mátch elöl
          if (a.__titleHit !== b.__titleHit) return a.__titleHit ? -1 : 1;
          // 2. Vendor priority
          const vp = vendorPriority(b.vendor) - vendorPriority(a.vendor);
          if (vp !== 0) return vp;
          // 3. Stabil sorrend
          return a.__origIdx - b.__origIdx;
        });

        const productsHtml = products.map(p => `
          <a href="${p.url}" class="at-search-result">
            <div class="at-search-result-image">
              <img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy" width="80" height="80">
            </div>
            <div class="at-search-result-info">
              <div class="at-search-result-title">${escapeHtml(p.title)}</div>
              <div class="at-search-result-price">${formatPrice(p.price)}</div>
            </div>
            <svg class="at-search-result-arrow" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
            </svg>
          </a>`).join('');
        // "Összes találat megtekintése" — AZ EREDETI query az URL-ben és a label-ben
        const viewAllHtml = `
          <a href="${searchUrl}?q=${encodeURIComponent(original)}&type=product" class="at-search-view-all">
            <span>${strings.view_all} ("${escapeHtml(original)}")</span>
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
            </svg>
          </a>`;
        results.innerHTML = productsHtml + viewAllHtml;
        results.classList.add('is-visible');
      }).catch(err => {
        console.error('Search error:', err);
      });
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[m]));
  }
})();
